export default __webpack_public_path__ + "static/media/9.06bb2e04.jpg";